import React from "react";
import { TopLevelContainer } from '@xo-union/tk-component-grid';
import BreadcrumbList from './BreadcrumbList'
import styles from './top_styles.css'

export default class TopBreadcrumb extends React.Component {

  static defaultProps = {
    labels: [],
    mobileTopLabels: [],
    isMobile: false
  };

  constructor(props){
    super(props);

    this.state = {
      isMobile: props.isMobile,
      firstRender: true
    };
  }

  onWindowResize = () => {
    let isMobile = $(window).width() < 768;

    if(isMobile != this.state.isMobile){
      this.setState({isMobile})
    }
  };

  componentDidMount() {
    this.setState({firstRender: false});
    this.onWindowResize();

    if(window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize)
    }
  }

  desktopLabels = () => {
    return this.props.labels;
  };

  mobileLabels = () => {
    let showLabels = this.props.mobileTopLabels;

    return showLabels.length && showLabels[0].link && showLabels[0].link.length ? showLabels : []
  };

  breadcrumb = (props) => {
    let trackingProps = {
      "data-user-decision-area": "top breadcrumb"
    };
    return <BreadcrumbList {...props} trackingProps={trackingProps}></BreadcrumbList>
  };

  desktopBreadcrumb = () => {
    let props = {
      labels: this.desktopLabels(),
      className: styles['top-ol-desktop']
    };
    return this.breadcrumb(props)
  };

  mobileBreadcrumb = () => {
    let props = {
      labels: this.mobileLabels(),
      caretIconName: 'caret_left',
      className: styles['top-ol-mobile']
    };

    return this.breadcrumb(props)
  };

  isDesktop = () => {
    return !this.state.isMobile;
  };

  isMobile = () => {
    return this.state.isMobile;
  };

  render() {
    let className = this.mobileLabels().length ? '' : 'breadcrumb-container-none';

    return <nav className={`${styles['breadcrumb-container-top']} ${styles[className]}`} aria-label="breadcrumbs">
             {this.state.firstRender || this.isMobile() ? this.mobileBreadcrumb() : ''}
             {this.state.firstRender || this.isDesktop() ? <TopLevelContainer>{this.desktopBreadcrumb()}</TopLevelContainer> : ''}
           </nav>
  }
}
